import React from "react";
import "./Footer.css";

import { useSiteContext } from "../../contexts/SiteContext";
import { getImageUrl } from "../../services/fileService";

// Internal linklerin başına "/" garantiler; dış linkleri (http, mailto, tel, #) olduğu gibi bırakır.
const normalizeUrl = (url) => {
  if (!url) return "#";
  if (/^(https?:|mailto:|tel:|#|\/)/i.test(url)) return url;
  return `/${url}`;
};

const Footer = () => {
  const { currentLanguageCode, getSection } = useSiteContext();

  // Footer Section Data
  const footerData = getSection("footer_menu");

  //left_info_box
  const leftınfoData = footerData?.left_info_box;

  // LEft Menu

  const leftMenuData = footerData?.left_menu;

  //center_menu
  const centerMenuData = footerData?.center_menu;

  //right_menu
  const rightMenuData = footerData?.right_menu;

  //logo_section
  const logoSectionData = footerData?.logo_section;

  //bottom_bar
  const bottomBarData = footerData?.bottom_bar;

  return (
    <footer className="footer">
      <section className="footer-banner">
        <h3 className="footer-title">
          SOLUTION <br className="mobile-only" /> IN MOTION
        </h3>
        <div className="footer-blur-circle"></div>
        <div className="footer-watermark"></div>
        <img
          src="/world-resized-1.webp"
          alt="Footer world"
          className="footer-world"
          loading="lazy"
          width="1200"
          height="600"
        />
      </section>
      <section className="footer-content" style={{ paddingTop: 64 }}>
        <div className="footer-container">
          {/* Sol taraf - Logo ve İletişim Bilgileri */}
          <div className="footer-left">
            <div className="footer-logo">
              <img src={getImageUrl(leftınfoData?.asset)} alt="MNG Airlines" />
            </div>
            <div className="footer-contact">
              <p className="contact-item cont-item">
                <strong>T.</strong> {leftınfoData?.phone}
              </p>
              <p className="contact-item cont-item">
                <strong>M.</strong> {leftınfoData?.mail}
              </p>
              <div className="contact-address">
                <p dangerouslySetInnerHTML={{ __html: leftınfoData?.adress }} />
              </div>
              <div className="social-links">
                {leftınfoData?.social_medias?.map((social, idx) => (
                  <a
                    key={idx}
                    href={social.url}
                    className="social-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={getImageUrl(social.asset)}
                      alt="social"
                      style={{ width: 24, height: 24, objectFit: "contain" }}
                    />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* Orta kısım - Menüler */}
          <div className="footer-center">
            {/* 1. Sütun: KURUMSAL ve Diğer Ana Başlıklar (Network, News, Contact vb.) */}
            <div className="footer-column">
              {/* İlk Eleman (Genelde Kurumsal): Başlık + Submenu Listesi */}
              {leftMenuData && leftMenuData[0] && (
                <div style={{ marginBottom: 20 }}>
                  <a
                    href={normalizeUrl(leftMenuData[0].url)}
                    style={{
                      marginBottom: 20,
                      display: "block",
                      fontWeight: "bold",
                    }}
                  >
                    {leftMenuData[0].title}
                  </a>
                  {leftMenuData[0].submenus &&
                    leftMenuData[0].submenus.length > 0 && (
                      <ul style={{ marginTop: 20, marginBottom: 30 }}>
                        {leftMenuData[0].submenus.map((sub, i) => (
                          <li key={i}>
                            <a href={normalizeUrl(sub.url)}>{sub.title}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                </div>
              )}

              {/* Diğer Ana Başlıklar (Uçuş Ağı, İletişim vb.) - Sadece Başlık */}
              {leftMenuData &&
                leftMenuData.length > 1 &&
                leftMenuData.slice(1).map((menu, idx) => (
                  <div
                    key={`left-menu-extra-${idx}`}
                    style={{ marginBottom: 15 }}
                  >
                    <a
                      href={normalizeUrl(menu.url)}
                      style={{ fontWeight: "bold", display: "block" }}
                    >
                      {menu.title}
                    </a>
                  </div>
                ))}
            </div>

            {/* 2. Sütun: HİZMETLER (SERVICES) */}
            <div className="footer-column">
              {centerMenuData &&
                centerMenuData.length > 0 &&
                centerMenuData.map((menu, idx) => (
                  <div key={`center-menu-${idx}`} style={{ marginBottom: 30 }}>
                    <a
                      href={normalizeUrl(menu.url)}
                      style={{
                        marginBottom: 20,
                        display: "block",
                        fontWeight: "bold",
                      }}
                    >
                      {menu.title}
                    </a>
                    {menu.submenus && menu.submenus.length > 0 && (
                      <ul style={{ marginTop: 20 }}>
                        {menu.submenus.map((sub, i) => (
                          <li key={i}>
                            <a href={normalizeUrl(sub.url)}>{sub.title}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
            </div>

            {/* 3. Sütun: POLİTİKALAR (POLICIES) */}
            <div className="footer-column">
              {rightMenuData && rightMenuData.length > 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "15px",
                  }}
                >
                  {rightMenuData.map((item, idx) => (
                    <a
                      key={idx}
                      href={
                        item.url
                          ? `/${currentLanguageCode === "tr" ? "politikalar" : "policies"}?section=${item.url}`
                          : "#"
                      }
                      style={{ display: "block" }} // Başlık görünümü için (Görseldeki gibi)
                    >
                      {item.title}
                    </a>
                  ))}
                </div>
              )}
            </div>
          </div>
          {/* Sağ taraf - Logolar */}
          <div className="footer-right">
            <div className="footer-logos">
              {logoSectionData &&
                logoSectionData.length > 0 &&
                logoSectionData[0].logo &&
                logoSectionData[0].logo.length > 0 &&
                logoSectionData[0].logo.map((logo, j) => (
                  <div
                    key={j}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "80px",
                    }}
                  >
                    <img
                      src={getImageUrl(logo.asset)}
                      alt="Partner"
                      width="150"
                      height="80"
                      style={{
                        maxHeight: "100%",
                        maxWidth: "150px",
                        objectFit: "contain",
                      }}
                      loading="lazy"
                    />
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* Alt kısım - Copyright ve Legal Links */}
        <div className="footer-bottom">
          <div className="footer-container">
            <p className="copyright">{bottomBarData?.copyright_text}</p>
            <div className="legal-links">
              {bottomBarData?.bottom_docs?.map((doc, i) => (
                <a
                  target="_blank"
                  key={`doc-${i}`}
                  href={getImageUrl(doc.asset)}
                  rel="noopener noreferrer"
                >
                  {doc.title}
                </a>
              ))}
              {bottomBarData?.bottom_bar_page?.map((page, i) => (
                <a
                  target="_blank"
                  key={`page-${i}`}
                  href={normalizeUrl(page.url)}
                  rel="noopener noreferrer"
                >
                  {page.title}
                </a>
              ))}
            </div>
          </div>
        </div>
      </section>
    </footer>
  );
};

export default Footer;
